import AddToCartBundlePdpContainer from './AddToCartBundlePdpContainer';

export default AddToCartBundlePdpContainer;
